import Link from "next/link";

export default function FoundryLink(props) {
  return <Link scroll={false} {...props} />;
}
